export default "__VITE_ASSET__DBCOrRyr__"